import React, { useState, useEffect, useRef } from 'react'
import HanziWriter from 'hanzi-writer'
import { speech } from '../utils/utils'
import { GrGamepad } from '@react-icons/all-files/gr/GrGamepad'
import { Link, graphql, navigate } from 'gatsby'
import { IoMdArrowBack } from '@react-icons/all-files/io/IoMdArrowBack'

const Hanzi = ({ data }) => {
  const charEl = useRef(null)
  function printStrokePoints(data) {
    var pointStrs = data.drawnPath.points.map(
      (point) => `{x: ${point.x}, y: ${point.y}}`
    )
  }

  function updateCharacter(character) {
    //document.querySelector('#target').innerHTML = ''
    charEl.current.innerHTML = ''
    var writer = HanziWriter.create('target', character, {
      width: 350,
      height: 400,
      renderer: 'svg',
      radicalColor: '#166E16',
      onCorrectStroke: printStrokePoints,
      onMistake: printStrokePoints,
      showCharacter: false,
      showHintAfterMisses: 1,
      highlightOnComplete: true,
    })
    window.writer = writer
    quiz(false)
  }

  function quiz(open_speech = true) {
    if (open_speech) {
      speech('我来写')
    }
    writer.quiz({
      onMistake: function (strokeData) {
        //speech('不对, 再试试')
      },
      onCorrectStroke: function (strokeData) {
        console.log(strokeData.strokesRemaining)
        if (strokeData.strokesRemaining >= 1) {
          //speech('对了')
        }
      },
      onComplete: function (summaryData) {
        const stringArray = [
          '你真棒',
          '你是个天才',
          '你真厉害',
          '你很聪明',
          '佩服你',
          '你是个人才',
          '了不起,继续努力',
        ]
        const randomIndex = Math.floor(Math.random() * stringArray.length)
        speech(stringArray[randomIndex])
      },
    })
  }
  function animate() {
    speech('老师教我写')
    writer.animateCharacter()
  }

  function handleCharacterClick(e) {
    const char = e.target.getAttribute('data-char')
    updateCharacter(char)
    speech(char)
    quiz(false)
  }

  if (data.length === 0) {
    data = ['我']
  }

  useEffect(() => {
    updateCharacter(data[0])
  }, [data])
  return (
    <div>
      <form className="js-char-form char-form">
        <label>点击选择汉字:</label>
        <div className="char-container">
          {data.map((item) => (
            <div
              className="char"
              key={item}
              data-char={item}
              onClick={handleCharacterClick}
            >
              {item}
            </div>
          ))}
        </div>
      </form>
      <div className="actions">
        <button className="js-animate" onClick={animate}>
          动画演示
        </button>
        <button className="js-quiz" onClick={quiz}>
          自我测试
        </button>
        <Link to="/phrase">
          <button>汉字练习</button>
        </Link>
        <Link to="/game">
          <button>
            汉字游戏
            <GrGamepad />
          </button>
        </Link>
        <button onClick={() => navigate(-1)}>
          回退 <IoMdArrowBack />
        </button>
      </div>
      <div id="target" ref={charEl}></div>
    </div>
  )
}

export default Hanzi
